var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonkindlesvglogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 44,
    viewBox: "0 0 150 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Amazon_kindle_svg_logo",
    "data-name": "Amazon kindle svg logo",
    transform: "translate(-6870 -5337)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4979",
    "data-name": "Rectangle 4979",
    width: 150,
    height: 44,
    transform: "translate(6870 5337)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Amazon_Kindle",
    "data-name": "Amazon Kindle",
    transform: "translate(6806.7 5187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34252",
    "data-name": "Path 34252",
    d: "M140.092,230.369c-4.771,3.507-11.658,5.371-17.6,5.371a31.773,31.773,0,0,1-21.515-8.214c-.442-.411-.063-.948.474-.632a42.742,42.742,0,0,0,37.943,2.369C140.218,228.916,140.881,229.769,140.092,230.369Z",
    transform: "translate(-24.958 -47.747)",
    fill: "#f49800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34253",
    "data-name": "Path 34253",
    d: "M218.6,226.255c-.6-.79-4.012-.379-5.56-.19-.474.063-.537-.348-.126-.632,2.717-1.927,7.2-1.358,7.709-.727.537.632-.126,5.118-2.685,7.266-.379.316-.758.158-.6-.284C217.934,230.267,219.2,227.045,218.6,226.255Z",
    transform: "translate(-101.473 -45.908)",
    fill: "#f49800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34254",
    "data-name": "Path 34254",
    d: "M213.242,180.438v-1.864a.465.465,0,0,1,.474-.474h8.341a.465.465,0,0,1,.474.474v1.611a2.487,2.487,0,0,1-.632,1.169l-4.3,6.161a9.371,9.371,0,0,1,4.771,1.011.878.878,0,0,1,.442.727v1.99c0,.284-.284.6-.6.411a9.545,9.545,0,0,0-8.814.032c-.284.158-.6-.158-.6-.442v-1.9a2.076,2.076,0,0,1,.316-1.264l4.992-7.172h-4.36A.492.492,0,0,1,213.242,180.438Z",
    transform: "translate(-101.584 -14.434)",
    fill: "#13110c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34255",
    "data-name": "Path 34255",
    d: "M111.57,191.585h-2.527a.452.452,0,0,1-.442-.442V178.127a.486.486,0,0,1,.474-.474h2.369a.48.48,0,0,1,.474.442V179.8h.063a3.492,3.492,0,0,1,6.635,0,3.59,3.59,0,0,1,3.507-2.4,3.63,3.63,0,0,1,2.938,1.422c.79,1.106.632,2.685.632,4.076v8.214a.486.486,0,0,1-.474.474h-2.527a.48.48,0,0,1-.442-.474v-6.887a20.671,20.671,0,0,0-.063-2.433,1.325,1.325,0,0,0-1.485-1.137,1.688,1.688,0,0,0-1.516,1.074,8.09,8.09,0,0,0-.221,2.5v6.887a.486.486,0,0,1-.474.474h-2.527a.48.48,0,0,1-.442-.474v-6.887c0-1.453.221-3.6-1.548-3.6-1.832,0-1.738,2.085-1.738,3.6v6.887C112.044,191.364,111.822,191.585,111.57,191.585Z",
    transform: "translate(-30.304 -13.955)",
    fill: "#13110c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34256",
    "data-name": "Path 34256",
    d: "M254.018,177.3c3.76,0,5.813,3.223,5.813,7.33,0,3.981-2.243,7.108-5.813,7.108-3.7,0-5.718-3.222-5.718-7.266C248.3,180.459,250.354,177.3,254.018,177.3Zm.032,2.654c-1.864,0-1.99,2.559-1.99,4.139s-.032,4.992,1.959,4.992c1.959,0,2.054-2.749,2.054-4.423a11.42,11.42,0,0,0-.379-3.444A1.605,1.605,0,0,0,254.05,179.954Z",
    transform: "translate(-125.869 -13.887)",
    fill: "#13110c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34257",
    "data-name": "Path 34257",
    d: "M293.77,191.654h-2.527a.48.48,0,0,1-.442-.474V178.163a.453.453,0,0,1,.474-.411h2.338a.443.443,0,0,1,.442.379v1.99h.063c.7-1.769,1.706-2.622,3.444-2.622a3.341,3.341,0,0,1,2.97,1.548c.663,1.043.663,2.78.663,4.044v8.151a.478.478,0,0,1-.474.411h-2.527a.472.472,0,0,1-.442-.411v-7.077c0-1.422.158-3.507-1.58-3.507a1.657,1.657,0,0,0-1.453,1.043,5.871,5.871,0,0,0-.411,2.464v7.014A.546.546,0,0,1,293.77,191.654Z",
    transform: "translate(-154.942 -14.023)",
    fill: "#13110c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34258",
    "data-name": "Path 34258",
    d: "M177.056,185.088a4.916,4.916,0,0,1-.474,2.685,2.063,2.063,0,0,1-1.769,1.169c-.979,0-1.548-.727-1.548-1.832,0-2.148,1.927-2.559,3.76-2.559v.537Zm2.559,6.192a.525.525,0,0,1-.6.063,5.816,5.816,0,0,1-1.453-1.706,4.986,4.986,0,0,1-4.17,1.832,3.593,3.593,0,0,1-3.791-3.949,4.263,4.263,0,0,1,2.717-4.139,17.439,17.439,0,0,1,4.771-.885v-.316a3.281,3.281,0,0,0-.316-1.832,1.705,1.705,0,0,0-1.422-.663A1.956,1.956,0,0,0,173.3,181.2a.573.573,0,0,1-.442.474l-2.464-.253a.436.436,0,0,1-.379-.537c.569-2.97,3.254-3.886,5.687-3.886a5.7,5.7,0,0,1,3.823,1.264c1.232,1.169,1.106,2.685,1.106,4.36v3.949a3.482,3.482,0,0,0,.948,2.338.486.486,0,0,1,0,.663c-.537.442-1.453,1.232-1.959,1.706Z",
    transform: "translate(-72.032 -13.681)",
    fill: "#13110c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34259",
    "data-name": "Path 34259",
    d: "M71.756,185.088a4.916,4.916,0,0,1-.474,2.685,2.063,2.063,0,0,1-1.769,1.169c-.979,0-1.548-.727-1.548-1.832,0-2.148,1.927-2.559,3.76-2.559v.537Zm2.559,6.192a.525.525,0,0,1-.6.063,5.816,5.816,0,0,1-1.453-1.706,4.986,4.986,0,0,1-4.17,1.832,3.593,3.593,0,0,1-3.791-3.949,4.263,4.263,0,0,1,2.717-4.139,17.439,17.439,0,0,1,4.771-.885v-.316a3.03,3.03,0,0,0-.316-1.832,1.705,1.705,0,0,0-1.422-.663A1.956,1.956,0,0,0,68,181.2a.573.573,0,0,1-.442.474l-2.464-.253a.436.436,0,0,1-.379-.537c.569-2.97,3.254-3.886,5.687-3.886a5.7,5.7,0,0,1,3.823,1.264c1.232,1.169,1.106,2.685,1.106,4.36v3.949a3.482,3.482,0,0,0,.948,2.338.486.486,0,0,1,0,.663c-.505.442-1.422,1.232-1.959,1.706Z",
    transform: "translate(0 -13.681)",
    fill: "#13110c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34260",
    "data-name": "Path 34260",
    d: "M343.456,177.63l-5.908-7.172h-.032v7.172H335.4V157h2.117v11.721h.032l5.055-4.865h2.78l-6.066,5.624,6.856,8.151Z",
    transform: "translate(-185.451)",
    fill: "#f49800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34261",
    "data-name": "Path 34261",
    d: "M374.085,163.07a1.485,1.485,0,1,1,1.485-1.485A1.483,1.483,0,0,1,374.085,163.07Zm-1.043,16.681V165.976h2.117v13.775Z",
    transform: "translate(-210.898 -2.121)",
    fill: "#f49800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34262",
    "data-name": "Path 34262",
    d: "M399.583,191.722v-8.467c0-1.706-.284-3.633-2.4-3.633-1.674,0-3.223,1.2-4.265,2.085v10.015H390.8V177.948h1.738l.284,1.674a7.876,7.876,0,0,1,4.929-2.022c1.99,0,3.949,1.422,3.949,4.865v9.257Z",
    transform: "translate(-223.348 -14.092)",
    fill: "#f49800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34263",
    "data-name": "Path 34263",
    d: "M439.677,177.915c-3.854,0-7.077-2.243-7.077-6.982a7.1,7.1,0,0,1,7.108-7.424,10.054,10.054,0,0,1,2.243.221V157h2.117v19.935A9.587,9.587,0,0,1,439.677,177.915Zm2.275-12.195a5.6,5.6,0,0,0-2.117-.348,5.108,5.108,0,0,0-5.055,5.434c0,3.128,1.706,5.339,5.308,5.339a5.343,5.343,0,0,0,1.9-.348V165.72Z",
    transform: "translate(-251.943)",
    fill: "#f49800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34264",
    "data-name": "Path 34264",
    d: "M481.2,177.915a2.244,2.244,0,0,1-2.4-2.527V157h2.117v17.408c0,1.3.316,1.58,1.137,1.58a2.483,2.483,0,0,0,.727-.095l.253,1.548A3.772,3.772,0,0,1,481.2,177.915Z",
    transform: "translate(-283.546)",
    fill: "#f49800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34265",
    "data-name": "Path 34265",
    d: "M498.175,185.182c0,2.622,1.516,4.992,4.486,4.992a6.76,6.76,0,0,0,3.349-1.011l.663,1.516a8.4,8.4,0,0,1-4.265,1.327c-4.391,0-6.508-3.538-6.508-7.456,0-3.981,2.275-6.95,5.592-6.95,3.538,0,5.5,2.812,5.5,7.108v.505h-8.814Zm3.349-5.782c-2.054,0-3.317,1.8-3.317,3.981h6.508C504.683,181.454,503.609,179.4,501.524,179.4Z",
    transform: "translate(-295.244 -14.092)",
    fill: "#f49800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonkindlesvglogo);
export default __webpack_public_path__ + "static/media/Amazon kindle svg logo.a0123585ad75e298c59b433e98c0ed0c.svg";
export { ForwardRef as ReactComponent };